/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import {Provider, connect} from 'react-redux';
import ShoppingCartContainer from "./ShoppingCartContainer";
import {getReduxStore} from "../../ReduxStore/store";
import {CartConfigContext} from "../../contexts/CartConfigContext";

function mapStateToProps(state) {
  let {cart = {}, vehicleSlice = {}, saveCartSlice = {}, scrapyardSlice = {}, userStore = {}} = state;

  // omit: cartItemId, contextKeys, callInNumber...
  return Object.assign(
    _.pick(saveCartSlice, 'saveCartStatus'),
    _.pick(cart,
      'shoppingCart', 'dynamicCart', 'newItems',
      'recommendations', 'forecasts', 'itemErrors'),
    _.pick(vehicleSlice, 'customerVehicle'),
    _.pick(scrapyardSlice, 'braintreeData', 'currentAgent'), // 2023-06 braintree token lives here now.
    _.pick(userStore, 'emailUser')
  );
}

let Wrapper = connect(mapStateToProps)(ShoppingCartContainer);

/*
 * 2026 properties list:
 *
 *     "currentAgent",
 *     "featureFlags",
 *     "cartCode",
 *     "now",
 *     "coreCart",
 *     "userCodes" ## new in 2026, like { taxExemptCode: [ {value, stateCode, cardNumber }, ... ], paymentToken: ... }
 *
 * @param cartConfig
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ShoppingCartApp({cartConfig, ...props}) {

  // FIXME: cartConfig is still passed as a prop because it's used
  // in too many places to change today.
  return <Provider store={getReduxStore()}>
    <CartConfigContext.Provider value={cartConfig}>
      <Wrapper cartConfig={cartConfig} {...props} />
    </CartConfigContext.Provider>
  </Provider>
}

